<template>
  <footer class="site-footer">
    <div class="container footer-content">
      <div class="footer-col">
        <div class="footer-logo">政经事 Roadlink GLB</div>
        <p class="footer-desc">一站式企业出海服务平台，提供出海测算、精选产品、AI 财税、出海案例、行业专家与政经动态等专业服务。</p>
      </div>
      <div class="footer-col">
        <h4>服务模块</h4>
        <ul>
          <li @click="openExternal('https://www.roadlinkglobal.com/#/destination')">出海测算</li>
          <li @click="$router.push('/ai-finance')">AI 财税</li>
          <li @click="$router.push('/products')">精选产品</li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>关于我们</h4>
        <ul>
          <li @click="$router.push('/about')">公司介绍</li>
          <li @click="$router.push('/about')">联系方式</li>
          <li @click="$router.push('/about')">商务合作</li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="copyright">© {{ currentYear }} 政经事 Roadlink GLB. 保留所有权利。</div>
        <div class="beian">
          备案号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备18114432号-2</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    openExternal (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #1a2f5e;
  color: #cdd8f0;
  margin-top: 40px;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  padding: 48px 20px 32px;
}

.footer-col {
  flex: 1;
  min-width: 220px;
}

.footer-logo {
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 14px;
}

.footer-desc {
  font-size: 14px;
  line-height: 1.8;
  opacity: 0.85;
}

.footer-col h4 {
  color: #fff;
  font-size: 16px;
  margin-bottom: 16px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
}

.footer-col li {
  font-size: 14px;
  line-height: 2.2;
  cursor: pointer;
  opacity: 0.85;
  transition: color 0.2s;
}

.footer-col li:hover {
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 0;
  font-size: 13px;
  text-align: center;
  opacity: 0.7;
}

.copyright {
  line-height: 1.8;
}

.beian {
  margin-top: 6px;
  line-height: 1.8;
}

.beian a {
  color: #cdd8f0;
  text-decoration: none;
}

.beian a:hover {
  color: #fff;
  text-decoration: underline;
}
</style>
